import React from 'react';

interface LogoMantaProps {
  width?: number;
  height?: number;
  variant?: 'full' | 'icon';
}

export function LogoManta({ width = 120, height = 40, variant = 'full' }: LogoMantaProps) {
  if (variant === 'icon') {
    return (
      <svg width={height} height={height} viewBox="0 0 60 60" fill="none">
        <defs>
          <linearGradient id="mantaGradIcon" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#E07B3D' }} />
            <stop offset="50%" style={{ stopColor: '#C45A2B' }} />
            <stop offset="100%" style={{ stopColor: '#8B4A2D' }} />
          </linearGradient>
        </defs>
        <path
          d="M5 50 L5 15 L25 35 L45 15 L45 50 L38 50 L38 28 L25 42 L12 28 L12 50 Z"
          fill="url(#mantaGradIcon)"
        />
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox="0 0 200 60" fill="none">
      <defs>
        <linearGradient id="mantaGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#E07B3D' }} />
          <stop offset="50%" style={{ stopColor: '#C45A2B' }} />
          <stop offset="100%" style={{ stopColor: '#8B4A2D' }} />
        </linearGradient>
      </defs>
      <path
        d="M5 50 L5 15 L25 35 L45 15 L45 50 L38 50 L38 28 L25 42 L12 28 L12 50 Z"
        fill="url(#mantaGrad)"
      />
      <text
        x="55"
        y="32"
        fontFamily="Arial Black, sans-serif"
        fontSize="24"
        fontWeight="bold"
        fill="#5D3A1A"
      >
        MANTA
      </text>
      <text
        x="55"
        y="48"
        fontFamily="Arial, sans-serif"
        fontSize="11"
        fill="#8B4A2D"
        letterSpacing="3"
      >
        ASSOCIADOS
      </text>
    </svg>
  );
}

export default LogoManta;
